import React, { Fragment } from 'react';
import { LibraryUploadStep } from '../../../context/MaterialPanelContext';
import { useRefCallback } from '@tencent/glue-react-use';
import { Uploading } from '../../Uploading/Uploading';
import { UploadSuccess } from '../../UploadSuccess/UploadSuccess';
import { UploadFail } from '../../UploadFail/UploadFail';
import { useRcMaterialPanel } from '../RcMaterialPanel/RcMaterialPanel';
export var MaterialType;
(function (MaterialType) {
  MaterialType["IMAGE"] = "image";
  MaterialType["VIDEO"] = "video";
})(MaterialType || (MaterialType = {}));
var videoAvatarSize = {
  width: 170,
  height: 127
};
export var UploadStatusModal = function UploadStatusModal(_ref) {
  var materialType = _ref.materialType;
  var _useRcMaterialPanel = useRcMaterialPanel(),
    step = _useRcMaterialPanel.step,
    errMsg = _useRcMaterialPanel.errMsg,
    setStep = _useRcMaterialPanel.setStep,
    currentUploadFileDetail = _useRcMaterialPanel.currentUploadFileDetail;
  var isImage = materialType === MaterialType.IMAGE;
  var retry = useRefCallback(function () {
    var nextStep = isImage ? LibraryUploadStep.LIBRARY_IMAGE_PANEL : LibraryUploadStep.LIBRARY_VIDEO_PANEL;
    setStep(nextStep);
  });
  var onClose = useRefCallback(function () {
    currentUploadFileDetail.abort();
    setStep(LibraryUploadStep.CLOSE);
  });
  var backToPanel = useRefCallback(function () {
    currentUploadFileDetail.abort();
    retry();
  });
  var uploadingModal = React.createElement(Uploading, {
    previewUrl: currentUploadFileDetail === null || currentUploadFileDetail === void 0 ? void 0 : currentUploadFileDetail.poster,
    avatarStyle: isImage ? undefined : videoAvatarSize,
    show: true,
    desc: isImage ? '图片上传中，请稍后...' : '视频转码中，请稍后...',
    onClose: backToPanel
  });
  var uploadSuccessModal = React.createElement(UploadSuccess, {
    previewUrl: currentUploadFileDetail === null || currentUploadFileDetail === void 0 ? void 0 : currentUploadFileDetail.poster,
    avatarStyle: isImage ? undefined : videoAvatarSize,
    onClose: onClose,
    show: true,
    onOk: onClose
  });
  var uploadFailModal = React.createElement(UploadFail, {
    onClose: onClose,
    previewUrl: currentUploadFileDetail === null || currentUploadFileDetail === void 0 ? void 0 : currentUploadFileDetail.poster,
    avatarStyle: isImage ? undefined : videoAvatarSize,
    show: true,
    desc: errMsg,
    onRetry: retry
  });
  var content;
  switch (step) {
    case LibraryUploadStep.UPLOADING:
      {
        content = uploadingModal;
        break;
      }
    case LibraryUploadStep.SUCCESS:
      {
        content = uploadSuccessModal;
        break;
      }
    case LibraryUploadStep.FAIL:
      {
        content = uploadFailModal;
        break;
      }
    default:
      {
        content = React.createElement(Fragment, null);
      }
  }
  return content;
};